import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  appDialogWrapper: {
    width: 'min(1000px, calc(100vw - 32px))',
    height: 'auto',
    maxHeight: MAX_PAGE_HEIGHT,
    borderRadius: '4px',
    maxWidth: 'calc(100vw - 32px)',
  },
  appDialogHeader: {
    padding: '24px',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',

    '& svg': {
      cursor: 'pointer',
    },
  },
  appDialogHeaderTitle: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.text.primary,
  },
  appDialogContent: {
    padding: '24px',
    width: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
    boxSizing: 'border-box',
  },
}));
